import axios, { clientContext } from './config'

const apiClient = {
  updateClient (data) {
    return axios.patch(`/api/clients/${clientContext.getUsername()}/`, data)
  },
  buyItem (data) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/buy_package_item/`, data)
  },
  buyAllItems (data) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/buy_all_unreturned_package_items/`, data)
  },
  getAllItemsPrice () {
    return axios.get(`/api/clients/${clientContext.getUsername()}/unreturned_package_items_price/`)
  },
  getCasePrice (data) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/case_price_quote/`, data)
  },
  purchaseCase (data) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/purchase_case/`, data)
  },
  getShippingEligibility () {
    return axios.get(`/api/clients/${clientContext.getUsername()}/shipping_eligibility/`)
  },
  registerExperiment (data) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/register_experiment/`, data)
  },
  getPaymentInfo () {
    return axios.get(`/api/clients/${clientContext.getUsername()}/payment/`)
  },
  setStyleColorRating (data) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/style_color_rating/`, data)
  },
  getValidatedShippingAddress () {
    return axios.get(`/api/clients/${clientContext.getUsername()}/validated_shipping_address/`)
  },
  getUnlockShipmentPricing () {
    return axios.get(`/api/clients/${clientContext.getUsername()}/unlock_shipment_pricing/`)
  },
  getReferrals () {
    return axios.get(`/api/clients/${clientContext.getUsername()}/referrals/`)
  },
  getBilling () {
    return axios.get(`/api/clients/${clientContext.getUsername()}/billing/`)
  },
  getBillingHistory (startingAfterId = null) {
    return axios.get(`/api/clients/${clientContext.getUsername()}/billing_history/`, { params: { starting_after_id: startingAfterId } })
  },
  postSupportRequest (data) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/support_request/`, data)
  },
  postDefaultPayment (data) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/default_payment/`, data)
  },
  checkReferralCodeAvailability (code) {
    return axios.get(`/api/clients/${clientContext.getUsername()}/referral_link_availability/`, { params: { code } })
  },
  cancelSubscription (cancelReason) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/cancel/`, cancelReason)
  },
  pauseSubscription (months) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/pause/`, { months })
  },
  unpauseSubscription () {
    return axios.post(`/api/clients/${clientContext.getUsername()}/unpause/`)
  },
  unlockShipments () {
    return axios.post(`/api/clients/${clientContext.getUsername()}/unlock_next_shipments/`, {})
  },
  getClientFollowers (clientId, share) {
    return axios.get( `/api/clients/${clientId}/followers/`, { params: { share } })
  },
  getClientFollowing (clientId, share) {
    return axios.get(`/api/clients/${clientId}/following/`, { params: { share } })
  },
  followClient (clientIdToFollow) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/follow/`, { client: clientIdToFollow })
  },
  unfollowClient (clientIdToUnFollow) {
    return axios.post(`/api/clients/${clientContext.getUsername()}/unfollow/`, { client: clientIdToUnFollow })
  },
  getSuggestedToFollow () {
    return axios.get('/api/clients/', { params: { type: 'suggestedFollow' } })
  },
  getRentalHistory (clientId, share, filter) {
    return axios.get(`/api/clients/${clientId}/rental_history_v2/`, { params: { filter, share } })
  },
  getReturnPackages (count = 5) {
    return axios.get('/api/return_packages/', { params: { count } })
  },
  submitCaseBackupSize (packageId, data) {
    return axios.post(`/api/packages/${packageId}/case_backup_size/`, data)
  },
  submitPickupRequest (data) {
    return axios.post('/api/packages/pickup_request/', data)
  },
  getFedExPickupConfirmationCode () {
    return axios.get(`/api/clients/${clientContext.getUsername()}/fedex_pickup_code/`)
  },
  getShareToken (feature, resource) {
    return axios.get(`/api/clients/${clientContext.getUsername()}/share_token/`, { params: { feature, resource } })
  },
  checkImpersonation () {
    return axios.get('/api/clients/get_impersonation_info/')
  }
}

export default apiClient
